<template>
    <div class="wrapper">
        <img class="bg-img" src="../../assets/pic_1.png" />
        <div class="store-info" v-if="storeData.bossPhone">
            <div class="store-name">
                <img class="store-logo" :src="storeData.coverImage" />
                <div class="name">{{ storeData.name }}</div>
            </div>
            <div class="borde-bottom-line"></div>
            <div class="boss-info">
                <p class="boss-name">店老板：{{ storeData.bossName }}</p>
                <p>店老板手机号：{{ storeData.bossPhone }}</p>
            </div>
        </div>

        <div class="tip-text">下载吉祥有约App，使用手机号登录即可</div>
        <div class="btn-group">
            <div class="service-btn btn">
                <img class="service-icon" src="@/assets/service.png" />
                <text @click="openService">联系客服</text>
            </div>
            <template v-if="showWxBtn">
                <wx-open-launch-app
                    id="jump-app"
                    appid="wxcf26e67f34abb5e5"
                    :extinfo="extinfo"
                    style="width: 210px;height: 40px;border-radius: 8px;"
                >  
                    <div v-is="'script'" type="text/wxtag-template">
                        <div style="
                            width: 210px;
                            background: #0F50C5 !important;
                            border-radius: 8px; 
                            height: 40px;
                            line-height: 40px; 
                            margin: auto;
                            color: #fff;
                            font-size: 16px;
                            text-align: center;"
                        >进入吉祥有约App</div>
                    </div>
                </wx-open-launch-app>
            </template>
            <div v-else class="openapp-btn btn" @click="jumpToApp">进入吉祥有约App</div>
        </div>
        <!-- <div class="tip-text mb-10">开店成功后点击左上角返回登录即可</div> -->
        <img class="introduce-img" src="@/assets/pic_3.png" />
    </div>
</template>

<script>
    import { reactive, ref, computed, onMounted } from 'vue'
    import { useRouter } from "vue-router"
    import { useRoute } from 'vue-router'
    import { useRequest } from './useHook/useRequest'
    import { customerService } from "@/utils/getCustomerService"
    import { useCache } from './useHook/useCache'
    import { isWeChat } from '@/utils/validate'

    export default {
        name: 'open-result',
        setup() {
            const { useApi } = useRequest()
            const { getCache, setCache } = useCache()
            const router = useRouter()
            const route = useRoute() 
            const storeData = reactive({})
            const showWxBtn = ref(isWeChat())
            const extinfo = computed(() => {
                let u = navigator.userAgent
                let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
                return isiOS ? 'jxyyService://' : ''
            })

            const jumpToApp = () => {
                try {
                    if (isWeChat()) {
                        router.push({ path: "/downapk" })
                    } else {
                        getApkInfo()
                    }
                } catch (error) {
                    router.push({ path: "/downapk" })
                    console.log('jumpToApp', error)
                }
            }

            const getApkInfo = async() => {
                try {
                    let u = navigator.userAgent
                    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1 //android终端或者uc浏览器
                    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
                    let { result } = await useApi({
                        url: '/h5/jump_app',
                        method: 'post'
                    })

                    if (result.success) {
                        if (isAndroid) {
                            let _clickTime = new Date().getTime()
                            let _count = 0, intHandle = null
                            let src = 'android://jxyy/splash'
                            window.location.href = src
                            intHandle = setInterval(() => {
                                _count++
                                let elsTime = new Date().getTime() - _clickTime
                                if (_count >= 100 || elsTime > 3000 ) {
                                    clearInterval(intHandle);
                                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                                    if (hidden) {
                                        window.close()
                                    } else {
                                        window.location.href = result.data.androidLink
                                    }
                                }
                            }, 20)
                        } else if (isiOS) {
                            let _clickTime = +(new Date())
                            let src = 'jxyyService://'
                            window.location.href = src
                            let _count = 0, intHandle = null

                            intHandle = setInterval(() => {
                                _count++
                                let elsTime =  +(new Date()) - _clickTime
                                if (_count >= 100 || elsTime > 3000 ) {
                                    clearInterval(intHandle);
                                    let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden || window.document.webkitHidden
                                    if (hidden) {
                                        setTimeout(window.close, 301)
                                    } else {
                                        window.location.href = result.data.iosLink
                                    }
                                }
                            }, 20)
                        } else {
                            window.location.href = result.data.androidLink
                        }
                    } else {
                        proxy.$toast(result.errorMessage)
                    }
                } catch (error) {
                    console.log('getApkInfo', error)
                }
            }

            const openService = async() => {
                try {
                    let { result } = await useApi({
                        url: '/base/kefu',
                        method: 'post'
                    }, { id: 0, AdCode: '' })

                    if (result.success) {
                        customerService(result.data)
                    } else {
                        proxy.$toast(result.errorMessage)
                    }
                } catch (error) {
                    console.log('getWechatUrlLink', error)
                }
            }

            const getWechatConfig = async() => {
                try {
                    const url = window.location.href.split('#')[0]
                    let { result } = await useApi({
                        url: '/h5/jssdk',
                        method: 'post'
                    }, { uri: url })

                    if (result.success) {
                        let btn = document.getElementById('jump-app')
                        let config = result.data
                        window.wx.config({
                            // debug: process.env.NODE_ENV == 'development' ? true : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.app_id, // 必填，企业号的唯一标识，此处填写企业号corpid
                            timestamp: Number(config.timestamp), // 必填，生成签名的时间戳
                            nonceStr: config.nonce_str, // 必填，生成签名的随机串
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            signature: config.signature, // 必填，签名
                            jsApiList: [], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                            openTagList: ['wx-open-launch-app']
                        })
                        window.wx.ready((res) => {
                            btn.addEventListener('error', (e) => {
                                if (e.detail.errMsg == 'launch:fail') {
                                    jumpToApp()
                                }
                            })
                        })
                        window.wx.error((err) =>{
                            console.log('err===>', err)
                            // jumpToApp()
                        })
                        btn.addEventListener('launch', () => {
                            console.log('success');
                        })
                        btn.addEventListener('error', (e) => {
                            jumpToApp()
                            console.log('fail', e.detail)
                        })
                    } else {
                        proxy.$toast(result.errorMessage)
                    }
                } catch (error) {
                    console.log('getWechatUrlLink', error)
                }
            }

            onMounted(() => {
                let { storeInfo } = route.params

                if(isWeChat()) {
                    getWechatConfig()
                }

                if (storeInfo !== void 0) {
                    Object.assign(storeData, JSON.parse(storeInfo))
                    setCache('storeData', storeInfo)
                } else {
                    Object.assign(storeData, getCache('storeData') ? JSON.parse(getCache('storeData')) : {})
                }
            })

            return {
                showWxBtn,
                extinfo,
                openService,
                jumpToApp,
                storeData
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper {
        padding: 0 12px;
        background: linear-gradient(180deg, #D9EEFF 0%, #F4F7FD 100%);

        .bg-img {
            width: 100%;
            height: 180px;
        }

        .store-info {
            background: #fff;
            padding: 12px 10px;
            margin-bottom: 12px;
            border-radius: 8px;
            font: {
                size: 14px;
                weight: bold;
            }

            .store-name {
                display: flex;
                align-items: center;

                .store-logo {
                    width: 43px;
                    height: 43px;
                    border-radius: 50%;
                }

                .name {
                    margin-left: 7px;
                    flex: 1;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-wrap: break-word;
                    white-space: normal !important;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }

            .borde-bottom-line {
                position: relative;
                margin: 12px 0;
                border: 1px dashed #E8ECF1;

                &::before {
                    position: absolute;
                    display: block;
                    content: "";
                    top: 0;
                    left: 0;
                    transform: translate(-17px, -50%);
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: #eaf4fe;
                }

                &::after {
                    position: absolute;
                    display: block;
                    content: "";
                    top: 0;
                    right: 0;
                    transform: translate(17px, -50%);
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: #eaf4fe;
                }
            }

            .boss-info {
                .boss-name {
                    margin-bottom: 10px;
                }
            }

        }

        .tip-text {
            font-size: 12px;
            text-align: center;
            color: #999;
        }

        .mb-10 {
            margin-bottom: 10px;
        }

        .border-bottom {
            margin: 12px;
            border: 1px dashed #E8ECF1;
        }

        .introduce-img {
            width: 100%;
            height: 580px;
        }

        .btn-group {
            margin: 12px 0 10px;
            display: flex;
            justify-content: space-between;

            .btn {
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 8px;
                text-align: center;
                font-size: 16px;
            }

            .service-btn {
                width: 130px;
                border: 1px solid #0F50C5;
                color: #0F50C5;

                .service-icon {
                    width: 20px;
                    height: 20px;
                    margin-right: 3px;
                }
            }

            .openapp-btn {
                width: 210px;
                color: #fff;
                background: #0F50C5;
            }
        }
    }
</style>